import { arrayOf, shape, string } from 'prop-types';
import React, { Component } from 'react';
import styles from './styles';

class InlineSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: ''
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleSubmit(e) {
    e.preventDefault();
    const term = this.state.term.trim().toLowerCase();
    window.location.href = `/search?q=${term}&filter=${this.props.filter}`;
  }
  handleChange(e) {
    e.preventDefault();
    this.setState({
      term: e.target.value
    });
  }
  render() {
    const { title, label, quickLinks } = this.props;
    return (
      <div className="InlineSearchForm">
        {title && <div className="InlineSearchForm__title">{title}</div>}
        <form className="InlineSearchForm__form" onSubmit={this.handleSubmit}>
          <label
            className="InlineSearchForm__label"
            htmlFor="InlineSearchInput"
          >
            <input
              id="InlineSearchInput"
              className="InlineSearchForm__input"
              type="text"
              value={this.state.term}
              onChange={this.handleChange}
              aria-label="Search"
            />
            {this.state.term === '' && (
              <span className="InlineSearchForm__label-message">{label}</span>
            )}
          </label>
          <button className="InlineSearchForm__submit" type="submit">
            Search
          </button>
        </form>
        {quickLinks && (
          <ul className="InlineSearchForm__links">
            {quickLinks.map(link => (
              <li key={link.url}>
                <a className="InlineSearchForm__link" href={link.url}>
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        )}
        <style jsx>{styles}</style>
      </div>
    );
  }
}

InlineSearchForm.defaultProps = {
  label: 'What are you looking for?',
  quickLinks: undefined,
  title: 'Search',
  // CLEANUP: This should be set as item data
  filter: 'recipes'
};

InlineSearchForm.propTypes = {
  label: string,
  quickLinks: arrayOf(
    shape({
      title: string,
      url: string
    })
  ),
  title: string,
  filter: string
};

export default InlineSearchForm;
